export default __webpack_public_path__ + "793d0f4e7134a8b0abcf9c29fdbdeb47.png";